
import React from 'react';
import AdminLayout from '@/components/admin/AdminLayout';

const IssueCertificatePage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Issue Certificate</h1>
        <p className="mt-4">Issue certificates to users.</p>
      </div>
    </AdminLayout>
  );
};

export default IssueCertificatePage;
